module.exports = __webpack_public_path__ + "static/media/bifoldDoor90.803c506b.png";